import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import Button from 'components/Elements/Button';
import Modal from 'components/modals';
import ChevronIcon from 'components/icons/Chevron';
import CommentForm from './CommentForm';
import { getComments } from 'utils/api/comments';
import { useRefMounted } from 'utils/hooks';
import cls from './Comments.module.scss';

const ViewAllButton = styled(Button)`
  display: flex;
  justify-content: center;
  color: #006838;
`;

const Comments = ({ ripspot }) => {
  const isMountedRef = useRefMounted();
  const [showAll, setShowAll] = useState(false);
  const [modalOpened, setModalOpened] = useState(false);
  const [data, setData] = useState([]);

  const comments = data.length > 3 ? (showAll ? data : data.slice(0, 3)) : data;

  const getCommentsData = useCallback(async () => {
    try {
      const commentsRes = await getComments(ripspot.id);

      if (isMountedRef.current) {
        setData(commentsRes);
      }
    } catch (err) {
      console.error(err);
    }
  }, [isMountedRef]);

  useEffect(() => {
    getCommentsData();
  }, [getCommentsData]);

  return (
    <div className={cls.root}>
      <h3 className={cls.title}>Memories</h3>
      <Button
        primary
        onClick={e => {
          e.preventDefault();
          setModalOpened(true);
        }}
      >
        Share A Memory
      </Button>
      {data.length > 0 ? (
        <>
          <div className={cls.list}>
            {comments.map(c => (
              <div className={cls.listItem} key={`comment-${c._id}`}>
                <div className={cls.name}>{c.name}</div>
                <div className={cls.message}>{c.message}</div>
              </div>
            ))}
          </div>
          {data.length > 3 && (
            <ViewAllButton
              link
              onClick={e => {
                e.preventDefault();
                setShowAll(!showAll);
              }}
            >
              <ChevronIcon
                fill="#006838"
                width={20}
                height={20}
                className={`${cls.viewAllIcon} ${showAll ? cls.up : ''}`}
              />
              <span className={cls.viewAllLabel}>View All Memories</span>
            </ViewAllButton>
          )}
        </>
      ) : (
        <div className={cls.noComments}>No memories yet.</div>
      )}
      <Modal
        isOpen={modalOpened}
        closeOnOutsideClick
        onRequestClose={() => {
          setModalOpened(false);
        }}
        title="New Comment"
      >
        <div className={cls.modalContainer}>
          <CommentForm
            onSubmit={() => {
              setModalOpened(false);
              getCommentsData();
            }}
            ripspot={ripspot}
          />
        </div>
      </Modal>
    </div>
  );
};

export default Comments;
